import {lazy} from "react";
import {
    HOME_PAGE_URI,
    SIGN_IN_COR_ID_PAGE_URI,
    SIGN_IN_CREDENTIAL_PAGE_URI,
    SIGN_IN_ERROR_PAGE_URI,
    SIGN_IN_PAGE_URI,
    SIGN_UP_PAGE_URI,
} from "../../../constants/uri.constant";

const Home = lazy(() => import('../../../page/Home'));
const SignIn = lazy(() => import('../../../page/Auth/SignIn'));
const SignUp = lazy(() => import('../../../page/Auth/SignUp'));
const CorIdSign = lazy(() => import('../../../page/Auth/CorIdSign'));
const EmailSign = lazy(() => import('../../../page/Auth/EmailSign'));
const AuthError = lazy(() => import('../../../page/Auth/AuthError'));
const NotFound = lazy(() => import('../../../page/NotFound'));

export interface RouteConfig {
    path: string;
    element?: any;
    wrapper?: any;
    exact?: boolean;
    hideLayout?: boolean;
    routes?: any[];
}

export interface RoutesConfig {
    withLayout: RouteConfig[];
    withoutLayout: RouteConfig[];
}

export const webRoutes = (): RoutesConfig => {
    const routes: RouteConfig[] = [
        {
            path: HOME_PAGE_URI,
            element: Home
        },
        {
            path: SIGN_IN_PAGE_URI,
            element: SignIn,
            hideLayout: true
        },
        {
            path: SIGN_UP_PAGE_URI,
            element: SignUp,
            hideLayout: true
        },
        {
            path: SIGN_IN_COR_ID_PAGE_URI,
            element: CorIdSign,
            hideLayout: true
        },
        {
            path: SIGN_IN_CREDENTIAL_PAGE_URI,
            element: EmailSign,
            hideLayout: true
        },
        {
            path: SIGN_IN_ERROR_PAGE_URI,
            element: AuthError,
            hideLayout: true
        },
        {
            path: "*",
            element: NotFound
        },
    ];

    return routes.reduce<RoutesConfig>((acc, route) => {
        if (route.hideLayout) {
            return {
                ...acc,
                withoutLayout: [...acc.withoutLayout, route]
            };
        }

        return {
            ...acc,
            withLayout: [...acc.withLayout, route]
        };
    }, { withLayout: [], withoutLayout: [] });
};
